import { useState } from 'react'
import { DeleteModal } from '../../../../components/common'
import { useMedical } from '../../../../hooks'
import { getError } from '../../../../utils'
import { showToast } from '../../../../utils/toast'

type Props = {
  onClose: () => void
  id?: string
}

export const DeleteMedical = ({ onClose, id }: Props) => {
  const [loading, setLoading] = useState(false)
  const { deleteMedical } = useMedical()

  const handleMedicalDelete = async () => {
    setLoading(true)
    try {
      await deleteMedical({ id: id || '' })
      showToast('Medical deleted successfully')
      onClose()
    } catch (err) {
      getError(err)
    }
    setLoading(false)
  }

  return (
    <DeleteModal
      description="Confirm that you want to delete this medical history"
      handleSubmit={handleMedicalDelete}
      isLoading={loading}
      onClose={onClose}
      title="Delete Medical History"
    />
  )
}
